/* Data translators between backend and frontend.
 *    Parsers format data for frontend (Redux-store).
 *    Unparsers format data for sending to backend.
 */
import { Storage } from "aws-amplify";
import _ from "lodash";

export const parseAsset = async (beAsset) => {
  const feAsset = { ...beAsset };

  const config = { expires: 60 * 60 * 24 }; // Presigned urls expire in 24h

  if (feAsset.media && feAsset.media !== "temp")
    feAsset.mediaUrl = await Storage.get(`${feAsset.media}`, config);

  if (feAsset.thumbnail && feAsset.thumbnail !== "temp")
    feAsset.thumbnailUrl = await Storage.get(`${feAsset.thumbnail}`, config);

  try {
    if (!feAsset.metadata) feAsset.metadata = {};
    else {
      do {
        feAsset.metadata = JSON.parse(feAsset.metadata) || {};
      } while (typeof feAsset.metadata !== "object");
    }
  } catch (error) {
    // console.log("Couldn't parse asset metadata '" + feAsset.metadata + "'");
  }

  return feAsset;
};

export const unparseAsset = (feAsset) => {
  const beAsset = _.omit(feAsset, ["file", "mediaUrl", "thumbnailUrl"]);
  beAsset.metadata = JSON.stringify(beAsset.metadata);

  return beAsset;
};
